export default __webpack_public_path__ + "static/media/logo_forrest.513c60d9.png";